<template lang="pug">
  main
    NavBarTPA
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-dark
          .column.is-half.is-offset-one-quarter.has-text-centered.section-title
            h1.title Consultas históricas  &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            .column(v-show="permisos.monitoreo == 1 || permisos.monitoreo == 11")
              b.has-text-black(@click="showFormNewYear = !showFormNewYear")
                a.button.is-light.is-rounded
                  | &nbspCrear nueva carpeta
            br

        .column.is-8.is-half.is-offset-one-quarter.has-text-centered(v-show="showFormNewYear")
          .column.is-9
            .field
              .control
                input.input.is-black(
                  type='text',
                  placeholder='Año de la nueva carpeta...',
                  v-model.number="formAnio.anio"
                )
            b.has-text-black(@click="crearCarpeta")
              a.button.is-black.is-rounded(
                style="margin-right:8px;"
              )
                | Guardar
            b.has-text-black(@click="showFormNewYear = false")
              a.button.is-light.is-rounded
                | Cancelar
        .columns.has-text-centered.is-centered.is-multiline.has-text-dark
          .column.is-2(v-for="a in anios" :key="a.id")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-calendar.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 {{ a.anio }}
                br
                a.button.is-dark.is-rounded.is-size-6(@click="openLista(a)") Consultar
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarTPA from '@/components/layout/NavBarTPA.vue'
import monitorServices from '@/services/sca/monitor'
import { mapState } from 'vuex'

export default {
  name: 'ConsultaHistorica',
  components: { Loader, NavBarTPA },
  data () {
    return {
      isLoading: false,
      showFormNewYear: false,
      formAnio: {
        id: null,
        anio: null,
      },
      anios: [],
    }
  },
  methods: {
    inciarComponente() {
      this.obtenerAnios()
    },

    obtenerAnios () {
      monitorServices.getAnios()
        .then ( data => {
          this.$store.commit('setCarpetasAnios', data)
          this.anios = this.carpertas_anios
        })
        .catch( e => {
          console.log(e)
        })
    },

    openLista(anio) {
      this.$store.commit('selectCarpetaAnio', anio)
      this.$router.push({ path: `/ConsultaHistorica/BT/` })
    },

    backPage() {
      this.$router.back()
    },

    crearCarpeta(){
      console.log('crear carpeta')
      monitorServices.insertAnio(this.formAnio)
        .then( res => {
          const { data } = res
          this.$store.commit('insertCarpetaAnio', data[0])
          this.anios = this.carpertas_anios
          this.showFormNewYear = false
        })
        .catch( e => {
          console.log(e)
        })
    }
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'permisos', 'carpertas_anios'])
  },
  created () {
    this.inciarComponente()
  },
}
</script>

<style lang="css" scoped>

  .image {
    display: inline-block;
  }

  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }

  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .card {
    color: #54545c;
  }

</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/monitor/ConsultaHistorica.vue